var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrmPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2226_1653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 30H28V28C28 27.4487 27.5518 27 27 27H21C20.4482 27 20 27.4487 20 28V30H18V28C18 26.3457 19.3457 25 21 25H27C28.6543 25 30 26.3457 30 28V30Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24C21.7939 24 20 22.2056 20 20C20 17.7944 21.7939 16 24 16C26.2061 16 28 17.7944 28 20C28 22.2056 26.2061 24 24 24ZM24 18C22.8975 18 22 18.897 22 20C22 21.103 22.8975 22 24 22C25.1025 22 26 21.103 26 20C26 18.897 25.1025 18 24 18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20H8V22H10V20Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20H12V22H18V20Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16H8V18H10V16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16H12V18H18V16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12H8V14H10V12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12H12V14H18V12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 5H18V4C18 2.897 17.1025 2 16 2H10C8.8975 2 8 2.897 8 4V5H5C3.8975 5 3 5.897 3 7V26C3 27.103 3.8975 28 5 28H14V26H5V7H8V9H18V7H21V13.9999H23V7C23 5.897 22.1025 5 21 5ZM16 7H10V4H16V7Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2226_1653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmPeople);
export default __webpack_public_path__ + "static/media/crm-people.22263680f612674d8400361fe8a1e277.svg";
export { ForwardRef as ReactComponent };